import axios from 'axios';
import config from '../config-api.json';
import {
  GetSearchImageType,
  GetSearchImageParamInImageTabType,
  GetRelatedWordType,
  GetRelatedWordParamType,
} from './type';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

export async function apiGetSearchImage(
  info: GetSearchImageParamInImageTabType
) {
  const paramsData: GetSearchImageParamInImageTabType = {
    page: info.page,
    page_count: info.page_count,
    query: info.query,
    targets: info.targets,
    type: info.type,
  };
  const response = await axios.get<GetSearchImageType>(
    `${apiInfo.api_url}/search_image/`,
    {
      params: paramsData,
    }
  );
  return response.data;
}

export async function apiGetRelatedWord(info: GetRelatedWordParamType) {
  const paramsData: GetRelatedWordParamType = {
    word: info.word,
  };
  const response = await axios.get<GetRelatedWordType>(
    `${apiInfo.api_url}/related_word/`,
    {
      params: paramsData,
      timeout: 10000,
    }
  );

  return response.data;
}
